import $ from 'jquery';
import '../vendor/jquery.truncate';

const namespace = 'truncate';

export default class Truncate {
  query = window.matchMedia('(min-width: 50em)');

  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          target: '.truncation__body',
          more: '.js-truncation-more',
        },
        classes: {
          visible: 'is-visible',
          active: 'is-applied',
        },
        length: 130,
        desktopLength: 240,
        labels: {
          more: 'data-truncate-more',
          less: 'data-truncate-less',
        },
      },
      options,
    );

    this.$el = $(el);
    this.$target = this.$el.find(this.options.selectors.target);
    this.$more = this.$el.find(this.options.selectors.more);
    this.data = this.$target.html();

    this.moreLabel = this.$el.attr(this.options.labels.more);
    this.lessLabel = this.$el.attr(this.options.labels.less);

    this.bind();
    this.handleQuery(this.query);
  }

  bind() {
    this.$more.on(`click.${namespace}`, this.handleClick.bind(this));
    this.handleQueryBind = this.handleQuery.bind(this);
    this.query.addListener(this.handleQueryBind);
  }

  handleQuery(event) {
    if (event.matches) {
      return this.applyTruncation({
        length: this.options.desktopLength,
        words: true,
      });
    }

    return this.applyTruncation({
      length: this.options.length,
      words: true,
    });
  }

  applyTruncation(options) {
    const truncation = $.truncate(this.data, options);

    this.truncation = truncation;
    this.$target.html(truncation);

    this.reset();

    if (truncation === this.data) {
      this.$el.removeClass(this.options.classes.active);
      return;
    }

    this.$el.addClass(this.options.classes.active);
  }

  reset() {
    this.$more.text(this.moreLabel);
    this.$el.removeClass(this.options.classes.visible);
  }

  handleClick() {
    if (this.isVisible()) {
      this.$target.html(this.truncation);
      this.$more.text(this.moreLabel);
    } else {
      this.$target.html(this.data);
      this.$more.text(this.lessLabel);
    }

    this.$el.toggleClass(this.options.classes.visible);
  }

  isVisible() {
    return this.$el.hasClass(this.options.classes.visible);
  }

  unbind() {
    this.$more.off(`click.${namespace}`);
    this.query.removeListener(this.handleQueryBind);
  }
}
